module.exports = __webpack_public_path__ + "img/options-lifestyle.158d4bd8.svg";